import { useEffect, useRef } from 'react';

/**
 * 定时轮询。
 *
 * 只用在「AI 研判正在跑」这类有明确终点的场景：`active` 为 false 时立即停止，
 * 组件卸载时清掉定时器，标签页切到后台时暂停（免得回来时攒了一堆请求）。
 *
 * 刻意不做通用请求库：研判接口自带状态机，轮询到终态就停，比缓存失效策略更直接。
 */
export function usePolling(callback: () => void | Promise<void>, intervalMs: number, active: boolean): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!active) return;

    let stopped = false;
    const tick = () => {
      if (stopped) return;
      if (document.visibilityState === 'hidden') return;
      void callbackRef.current();
    };

    const timer = window.setInterval(tick, intervalMs);
    return () => {
      stopped = true;
      window.clearInterval(timer);
    };
  }, [intervalMs, active]);
}
